"use client";

import { c as _c } from "react/compiler-runtime";
import { useGSAP } from "@gsap/react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { RefObject } from "react";
if (typeof window !== "undefined") {
  gsap.registerPlugin(ScrollTrigger);
}
export const useStackingEffect = (sectionRef, cardSelector, t0) => {
  const $ = _c(9);
  const isEnabled = t0 === undefined ? true : t0;
  let t1;
  if ($[0] !== cardSelector || $[1] !== isEnabled || $[2] !== sectionRef) {
    t1 = () => {
      if (!isEnabled || window.innerWidth < 1024) {
        return;
      }
      const cards = gsap.utils.toArray(cardSelector);
      if (cards.length === 0) {
        return;
      }
      const master = gsap.timeline({
        scrollTrigger: {
          trigger: sectionRef.current,
          start: "top top",
          end: `+=${cards.length * 3000}`,
          pin: true,
          scrub: 1.5,
          anticipatePin: 1
        }
      });
      cards.forEach((card, i) => {
        const chars = card.querySelectorAll(".reveal-char");
        const label = `card-${i}`;
        if (i > 0) {
          master.fromTo(card, {
            yPercent: 100
          }, {
            yPercent: 0,
            duration: 3,
            ease: "power1.inOut"
          }, label);
        }
        master.to(chars, {
          opacity: 1,
          stagger: 0.01,
          duration: 1.5,
          ease: "none"
        }, ">");
      });
      return () => {
        master.scrollTrigger?.kill();
        master.kill();
      };
    };
    $[0] = cardSelector;
    $[1] = isEnabled;
    $[2] = sectionRef;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== isEnabled) {
    t2 = [isEnabled];
    $[4] = isEnabled;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== sectionRef || $[7] !== t2) {
    t3 = {
      scope: sectionRef,
      dependencies: t2
    };
    $[6] = sectionRef;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  useGSAP(t1, t3);
};